import React from "react";
import swal from "sweetalert";
import { imgBaseUrl } from "../../utils/url";
import { onDownloadImageCT } from "../../utils/helper";
import { showCongratulations } from "../../utils/misc";

export default class DownloadBtnCommon extends React.Component {

  onImageDownload = () => {
    var link = document.createElement("a");
    var template_url = this.props.pageData.template_url;
    var dnldImgURL = imgBaseUrl + template_url;
    link.href =
      "https://api.narendramodi.in/api/loadone?link=" +
      dnldImgURL +
      "&x=www.facebook.com";
    let name = template_url.split("/")[0];
    name = name[name.length - 1];
    link.download = name;
    document.body.appendChild(link);
    link.target = "_blank";
    link.click();
    document.body.removeChild(link);
    swal("Thank you for downloading.");
    console.log("this.props",this.props);
    onDownloadImageCT({ imagelink: dnldImgURL, ...this.props.pageData, module: this.props.module });
    showCongratulations(this.props.module)
  };

  render() {
    return <div onClick={this.onImageDownload}>{this.props.children}</div>;
  }
}
